import { render, staticRenderFns } from "./DeleteAccountDialog.vue?vue&type=template&id=3a1216ff&"
import script from "./DeleteAccountDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports